import HowToRegIcon from '@mui/icons-material/HowToReg';
import { Dialog, DialogContent, Stack, Typography } from '@mui/material';

import type { IntakeStatusBaseSteps } from '@shared/patient-intake-status';

import { useAuth } from '../../../../../../hooks/index.js';
import { getActionedByName } from '../../../utils';
import { usePatientIntakeStatusContext } from '../../../hooks';
import { IdentityVerification } from '../../../../../../components/patient-documents/identity-verification/IdentityVerification.jsx';

type ViewIdVerificationModalProps = {
  step: IntakeStatusBaseSteps['ID_VERIFICATION'];
  onClose: () => void;
};

const ViewIdVerificationModal = ({ step, onClose }: ViewIdVerificationModalProps) => {
  const { user } = useAuth();

  const verifiedByName = getActionedByName({ currentUserId: user?.uid, step });
  const { actionedAt } = step.currentStatus;

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogContent>
        <Stack alignItems="center" justifyContent="center" gap={1}>
          <HowToRegIcon color="success" />
          <Typography variant="h6">ID Verification Complete</Typography>

          {!!verifiedByName && (
            <Typography variant="body1" gutterBottom>
              Verified by {verifiedByName}
            </Typography>
          )}

          {!!actionedAt && (
            <Typography variant="body2" gutterBottom>
              on {actionedAt.toDate().toLocaleString()}
            </Typography>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

type IdVerificationModalProps = {
  step: IntakeStatusBaseSteps['ID_VERIFICATION'];
  isOpen: boolean;
  onClose: () => void;
};

export const IdVerificationModal = ({ step, isOpen, onClose }: IdVerificationModalProps) => {
  const { patientId } = usePatientIntakeStatusContext();

  const { status } = step.currentStatus;

  if (status === 'COMPLETED') {
    return <ViewIdVerificationModal step={step} onClose={onClose} />;
  }

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <IdentityVerification patientId={patientId} onSuccess={onClose} />
    </Dialog>
  );
};
